module.exports = __webpack_public_path__ + "static/image-2-d7618e134b54e63d937714f63aa4a049.png";